import React from 'react';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import EyeIcon from '@avila-tek/ui/src/icons/EyeIcon';
import { Input } from '@avila-tek/ui/src/input/Input';
import Link from 'next/link';
import Line from '@avila-tek/ui/src/icons/Line';
import { useNotify } from '../../hooks/useNotify';
import { useCompanyBranding } from '../../hooks';
import { Color } from '../../models';
import { Button } from '../shared';

function SignInForm() {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const notify = useNotify();
  const router = useRouter();
  const [companyBranding] = useCompanyBranding();
  const [showPassword, setShowPassword] = React.useState(false);
  const callbackUrl = (router.query?.callbackUrl as string) ?? '/';

  // We expect companibranding.colors to be different from null so that we can set the styles.
  React.useEffect(() => {
    if (!companyBranding?.colors) return;
    // Lets iterate over the colors and set the styles
    companyBranding?.colors?.forEach((color: Color) => {
      const shadeKeys = Object.keys(color.shades);
      shadeKeys.forEach((shade) => {
        document.documentElement.style.setProperty(
          `${color.name}-${shade}`,
          color.shades[shade]
        );
      });
    });
  }, [companyBranding?.colors]);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const { ok, error } = await signIn('credentials', {
        email,
        password,
        redirect: false,
        userType: 'client',
      });
      if (ok) {
        return router.push('/sections' as string);
      }
      notify(error, 'error');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="gap-y-5 flex flex-col bg-system-100">
      <h2 className="text-xl text-center sm:text-3xl text-text-black font-semibold mx-auto ">
        Empieza a disfrutar de beneficios exclusivos
      </h2>
      <span className="text-sm sm:text-base text-center text-text-black">
        Inicia sesión para continuar en la plataforma de Meit!
      </span>
      <form
        className="space-y-5 flex flex-col text-gray-300"
        onSubmit={onSubmit}
      >
        <span className="block text-sm font-medium text-slate-700">
          Correo electrónico
        </span>
        <Input
          placeholder="Ingrese su correo electrónico"
          required
          className="border border-gray-300 text-gray-300"
          type="text"
          id="email"
          value={email}
          onChange={(e) => {
            e.preventDefault();
            setEmail(e.target.value);
          }}
        />
        <span className="block text-sm font-medium text-slate-700">
          Contraseña
        </span>
        <Input
          placeholder="Ingrese su contraseña"
          required
          id="password"
          onChange={(e) => {
            e.preventDefault();
            setPassword(e.target.value);
          }}
          type={showPassword ? 'text' : 'password'}
          className="border border-gray-300"
          rightIcon={
            <EyeIcon
              className="w-5 h-5 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setShowPassword(!showPassword);
              }}
            />
          }
        />
        <Link href="/reset-password">
          <div className="text-color-primary-text-300 w-full text-right cursor-pointer">
            ¿Olvidaste tu contraseña?
          </div>
        </Link>
        <Button type="submit">Ingresar</Button>
      </form>
      <div className="flex flex-row space-x-2">
        <Line />
        <div>
          <p className="text-gray-300 whitespace-nowrap">
            ¿No eres beneficiario?
          </p>
        </div>
        <Line />
      </div>
      <div className="flex flex-row gap-2">
        <Button
          type="button"
          className="bg-system-300 text-color-primary-text-300 hover:bg-color-primary-100"
        >
          <Link
            href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/company`}
            target="_blank"
          >
            <div className="text-center lg:text-lg xl:text-lg text-xs md:text-base">
              Soy empresa
            </div>
          </Link>
        </Button>
        <Button
          type="button"
          className="bg-system-300 text-color-primary-text-300 hover:bg-color-primary-100"
        >
          <Link
            href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/ally`}
            target="_blank"
          >
            <div className="text-center lg:text-lg xl:text-lg text-xs md:text-base">
              Soy aliado
            </div>
          </Link>
        </Button>
      </div>
    </div>
  );
}
export default SignInForm;
